import vClickOutside from "v-click-outside";
import moment from "moment";

export default {
	/**
	 * You can pass any <v-date-picker> prop to the <calendar> component.
	 *
	 * Here is a list of all available props:
	 * https://vcalendar.io/api/defaults.html
	 */
	inheritAttrs: false,

	directives: { clickOutside: vClickOutside.directive },

	props: {
		// Type: for single date: Date, for multiple: {start: Date, end: Date}
		value: { required: true },

		// If provided, it doesn't open the date-picker, it just shows the date in an input
		readonly: Boolean,

		// if true, will show two date inputs, else it will show one
		multiple: Boolean,
	},

	data() {
		return {
			isCalendarVisible: false,
			formats: { title: "MMM YYYY" },
			date: this.value,
		};
	},

	methods: {
		hideCalendar,
		formatDate,
	},
	watch: {
		date(value) {
			this.$emit("input", value);
			this.isCalendarVisible = false;
		},
	},
};

function hideCalendar() {
	this.isCalendarVisible = false;
}

function formatDate(date) {
	return moment(date).isValid() ? moment(date).format("DD.MM.YYYY") : this.$t("global.invalid_date");
}
